/**
 * crop接口统一管理
 */
import {get, patch, post} from './http'

/**
 * 获取作物类型列表
 */
export const getcroptypelist = () => get('goodsmanual/crop/category/list', {})

/**
 * 根据类型获取作物列表
 * @param categoryId
 */
export const getcroplist = (params) => get('goodsmanual/crop/list', params)


/**
 * 添加自定义作物
 * @param params
 */
export const addCustomCrop = (params) => post('goodsmanual/crop', params)

/**
 * 编辑自定义作物
 * @param cropId
 * @param params
 */
export const editCustomCrop = (cropId, params) => patch('goodsmanual/crop/' + cropId, params)

/**
 * 获取作物详情
 * @param cropId
 */
export const getCropDetail = (cropId) => get('goodsmanual/crop/' + cropId, {})
